import { getContentForMarket } from './market'
import { getSlug } from './slugs'
import { getUrl } from './urls'

/**
 *  Used in the Header to see if a ContentfulNavigationItem has
 * content for a ContentfulModalHubSpotForm
 *
 * @param {ContentfulNavigationItem} navigationItem
 * @param {String} slugPrefix
 * @returns
 */
export default function getButtonAction(
  navigationItem,
  slugPrefix,
  navigationItems,
  checkForProductParams = false
) {
  if (!navigationItem) {
    return { label: null, url: '#' }
  }

  const { content } = navigationItem
  let contentToUse = null

  if (Array.isArray(content) && content.length > 0) {
    contentToUse = getContentForMarket(content, slugPrefix)

    if (contentToUse && contentToUse['__typename'] === 'ModalHubSpotForm') {
      return {
        label: navigationItem?.title,
        url: null,
        modal: {
          title: contentToUse?.title,
          description: contentToUse?.description,
          hubSpotForm: contentToUse?.hubSpotForm
        }
      }
    }
  }

  let params = ''
  if (checkForProductParams && typeof window !== 'undefined') {
    const sections = document.querySelectorAll('section')
    const productFeatureInterests = new Set()

    for (const section of sections) {
      const links = section.querySelectorAll('a')
      for (const link of links) {
        const href = link.getAttribute('href')
        if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:'))
          continue

        try {
          const url = new URL(href, window.location.origin)
          if (url.searchParams.has('products_features_interest')) {
            productFeatureInterests.add(url.searchParams.get('products_features_interest'))
          }
        } catch (e) {
          // Skip invalid URLs
          //console.warn('Invalid URL:', href)
        }
      }
    }

    // Only add the parameter if all values are the same
    if (productFeatureInterests.size === 1) {
      const value = Array.from(productFeatureInterests)[0]
      params = `?products_features_interest=${value}`
    }
  }

  if (contentToUse) {
    return {
      label: navigationItem?.title,
      url: getSlug(contentToUse, slugPrefix) + params
    }
  }

  return {
    label: navigationItem?.title,
    url:
      getUrl({
        navItem: navigationItem,
        slugPrefix: slugPrefix,
        navigationItems: navigationItems
      }) + params
  }
}
